export default __webpack_public_path__ + "static/media/keller-before-after1-desktop.096810ab.svg";